<template>
    <div id="doubleCarousel">
        <div class="carOutBox" >
            <div v-for="(g, ix) in gameData" :key="ix">
                <div class="carContain animatsWords" v-if="ix == curInx">
                    <div class="carWords">
                        <h3 class="tit">
                            {{g.title}}
                        </h3>
                        <div class="carDivider"></div>
                        <div class="carDescri">
                            <span v-html="g.describe"></span>                    
                        </div>
                        <div class="medium-box" v-if="g.title==='Dragon Farm Adventure'">
                            <span>Follow us on</span>
                            <a href="https://www.youtube.com/channel/UCXpNd5kyZDKw5moj-Bm9yGg" target="_blank"><img src="../../../static/images/gameNewPic/youtube.png" /></a>
                            <a href="https://www.tiktok.com/@dragonfarmadventure1" target="_blank"><img src="../../../static/images/gameNewPic/tiktok.png" /></a>
                        </div>
                        <div class="carBtn">
                            <img :src="require('../../../static/images/gameNewPic/mac.svg')">
                            <img :src="require('../../../static/images/gameNewPic/google.svg')">
                        </div>
                    </div>
                </div>
                <div class="carBac animats" v-if="ix == curInx" :style="{background: 'url('+g.imgSrc+') no-repeat','background-size':'cover'}" @click="toNext"></div>
            </div>
            <div class="carouseBox">
                <!-- <el-carousel ref="carousel" trigger="click" @change="changeCarousel"  :autoplay="false" arrow="never">
                    <el-carousel-item v-for="(item, i) in gameData" :key="i">
                            <ul class="carCards " v-if="i == curInx">
                                <li class="cCard" v-for="(pic, inx) in item.listImg" :key="'img'+inx" :class="inx == 0 ? 'cCardOn' : 'cCardNot'">
                                    <img :src="pic.url" class="cCPic" :class="inx == 0 ? 'bigLight cCPicOn' : 'cCPicNot'" @click="setActiveItemCaro(pic.idx)">
                                </li>
                            </ul>
                    </el-carousel-item>
                </el-carousel> -->
                <otherCarousel @change="changeCarousel"></otherCarousel>
            </div>
            <div class="caPage">
                {{curPage}}/{{gameData.length}}
            </div>
        </div>
    
  </div>
</template>
<script>
import otherCarousel from './otherCarousel.vue'
import picUrl1 from '../../../static/images/gameNewPic/1.jpg'
import picUrl2 from '../../../static/images/gameNewPic/2.jpg'
import picUrl3 from '../../../static/images/gameNewPic/3.jpg'
import picUrl4 from '../../../static/images/gameNewPic/4.jpg'
import picUrl5 from '../../../static/images/gameNewPic/5.jpg'
import picUrl6 from '../../../static/images/gameNewPic/6.jpg'
import picUrl7 from '../../../static/images/gameNewPic/7.jpg'
import picUrl8 from '../../../static/images/gameNewPic/8.jpg'
import picUrl9 from '../../../static/images/gameNewPic/9.jpg'
import picUrl10 from '../../../static/images/gameNewPic/10.jpg'
import picUrl11 from '../../../static/images/gameNewPic/11.jpg'
export default {
    name: 'doubleCarousel',
    components: {otherCarousel},
    data() {
        return {
            curPage: '01',
            curInx: 0,
            gameData: [
                    {
                        title: '融融童话岛',
                        describe: '这是一个等待你探索和重建的美妙仙境。在这里，你拥有魔法，可以随心所欲地组合物品，收获丰富多样的元素和娃娃伙伴，驱散迷雾，解锁和构建属于自己的岛屿。</br></br></br> 联系邮箱：rongrongtonghuadao_kefu@bettagames.com',
                        imgSrc: require('../../../static/images/gameNewPic/11bac.jpg'),
                        listImg: [
                            {
                                idx: 0,
                                url: picUrl11,
                            },
                            {
                                idx: 1,
                                url: picUrl1,
                            },
                            {
                                idx: 2,
                                url: picUrl2,
                            },
                            {
                                idx: 3,
                                url: picUrl3,
                            },
                            {
                                idx: 4,
                                url: picUrl4
                            },
                        ]
                    },
                    {
                        title: 'Meeerge',
                        describe: '一个迷之漂流瓶中隐藏的危险力量夺走了部落的重要神器！在追寻它的旅途中，您需要借助老祭司代代相传的合成法术不断探索新的土地、维持部落的正常运转。为了拯救你的部落，马上率领你的部落成员展开冒险吧！',
                        imgSrc: require('../../../static/images/gameNewPic/1bac.jpg'),
                        listImg: [
                            {
                                idx: 1,
                                url: picUrl1,
                            },
                            {
                                idx: 2,
                                url: picUrl2,
                            },
                            {
                                idx: 3,
                                url: picUrl3,
                            },
                            {
                                idx: 4,
                                url: picUrl4,
                            },
                            {
                                idx: 5,
                                url: picUrl5
                            },
                        ]
                    },
                    {
                        title: 'Buddies',
                        describe: '文字兄弟是一款免费并且非常有趣的字谜游戏，可以锻炼你的大脑并扩充你的词汇量。每个面板都有独特的组成元素，带给你新奇特别的游戏体验！有个人模式和组队模式供你选择。你还可以和团队成员聊天或者分享生活趣事～',
                        imgSrc: require('../../../static/images/gameNewPic/2bac.jpg'),
                        listImg: [
                            {
                                idx: 2,
                                url: picUrl2,
                            },
                            {
                                idx: 3,
                                url: picUrl3,
                            },
                            {
                                idx: 4,
                                url: picUrl4,
                            },
                            {
                                idx: 5,
                                url: picUrl5,
                            },
                            {
                                idx: 6,
                                url: picUrl6,
                            },
                            
                        ]
                    },
                    {
                        title: 'Crossy',
                        describe: 'Word Crossy是一款轻松的拼词类游戏，只需在游戏面板上将字母连接成词。12000多关卡、上万的词汇从易到难让你在娱乐中学习，帮助你成为拼写大师。每日挑战和超级周赛带给你更大的挑战，也为你准备了绝佳的奖励！',
                        imgSrc: require('../../../static/images/gameNewPic/3bac.jpg'),
                        listImg: [
                            {
                                idx: 3,
                                url: picUrl3,
                            },
                            {
                                idx: 4,
                                url: picUrl4,
                            },
                            {
                                idx: 5,
                                url: picUrl5,
                            },
                            {
                                idx: 6,
                                url: picUrl6,
                            },
                            {
                                idx: 7,
                                url: picUrl7,
                            },
                        ]
                    },
                    {
                        title: 'Crush',
                        describe: '在寻找新的填字游戏吗？想要一款沉浸式游戏来锻炼大脑吗？来玩文字消除并开始你的文字之旅吧！玩法简单！只需滑动并连接字母即可找到字谜中的单词。享受经典的单词拼图，当您的猜测正确时，字母块会逐渐消失！',
                        imgSrc: require('../../../static/images/gameNewPic/4bac.jpg'),
                        listImg: [
                            {
                                idx: 4,
                                url: picUrl4,
                            },
                            {
                                idx: 5,
                                url: picUrl5,
                            },
                            {
                                idx: 6,
                                url: picUrl6,
                            },
                            {
                                idx: 7,
                                url: picUrl7,
                            },
                            {
                                idx: 8,
                                url: picUrl8,
                            },
                            
                        ]
                    },
                    {
                        title: 'Dragon Farm Adventure',
                        describe: '勇敢的冒险家们，欢迎来到Dragon Farm Adventure，开启寻龙之旅。你的好朋友辛西娅继承了一个神秘的岛屿，意外发现这里隐藏着不为人知的神龙一族。在这里你可以陪她一起建造龙乐园，培育神龙，也可以带着神龙一起去不同的场景冒险探索。',
                        imgSrc: require('../../../static/images/gameNewPic/5bac.jpg'),
                        listImg: [
                            {
                                idx: 5,
                                url: picUrl5,
                            },
                            {
                                idx: 6,
                                url: picUrl6,
                            },
                            {
                                idx: 7,
                                url: picUrl7,
                            },
                            {
                                idx: 8,
                                url: picUrl8,
                            },
                            {
                                idx: 9,
                                url: picUrl9,
                            },
                        ]
                    },
                    {
                        title: 'Solitaire Home Design',
                        describe: 'Solitaire Home Design，免费且极具挑战性的纸牌谜题游戏终于上线啦！ 艾迪和洛瑞是这款游戏的主角，在游戏中他们会讲述精彩的故事，改造并翻新整个岛屿，与此同时，你也能玩到各类有趣的解谜小游戏，来锻炼你的大脑吧！',
                        imgSrc: require('../../../static/images/gameNewPic/6bac.jpg'),
                        listImg: [
                            {
                                idx: 6,
                                url: picUrl6,
                            },
                            {
                                idx: 7,
                                url: picUrl7,
                            },
                            {
                                idx: 8,
                                url: picUrl8,
                            },
                            {
                                idx: 9,
                                url: picUrl9,
                            },
                            {
                                idx: 10,
                                url: picUrl10,
                            },
                            
                        ]
                    },
                    {
                        title: 'Mergical',
                        describe: '欢迎来到奇幻小岛Mergical！这是一片充满了魔法和幻想气息的神秘领地。在这里，你可以探索未知的世界，并建造一座属于自己的岛屿！一款完美的合成建造游戏。',
                        imgSrc: require('../../../static/images/gameNewPic/7bac.jpg'),
                        listImg: [
                            {
                                idx: 7,
                                url: picUrl7,
                            },
                            {
                                idx: 8,
                                url: picUrl8,
                            },
                            {
                                idx: 9,
                                url: picUrl9,
                            },
                            {
                                idx: 10,
                                url: picUrl10,
                            },
                            {
                                idx: 0,
                                url: picUrl11,
                            }, 
                            
                        ]
                    },
                    {
                        title: 'Tank Hero',
                        describe: '坦克大战已经打响，敌人已整装待发。而你需要做的是，使用你特殊的能力来抵御敌人坦克的入侵，并伺机发动反击。要记得，一旦你的坦克阵亡，一切便从零开始。',
                        imgSrc: require('../../../static/images/gameNewPic/8bac.jpg'),
                        listImg: [
                            {
                                idx: 8,
                                url: picUrl8,
                            }, 
                            {
                                idx: 9,
                                url: picUrl9,
                            }, 
                            {
                                idx: 10,
                                url: picUrl10,
                            }, 
                            {
                                idx: 0,
                                url: picUrl11,
                            }, 
                            {
                                idx: 1,
                                url: picUrl1,
                            }, 
                            
                        ]
                    },
                    {
                        title: 'Townest',
                        describe: "欢迎来到Townest：Alfred's Adventure！获取线索，帮助Alfred寻找他失踪的祖母。究竟谁才是这一切谜团的幕后黑手？这是一个神秘的魔法小镇。探索小镇来发现更多的秘密！完成关卡来帮助小镇恢复昔日繁华！",
                        imgSrc: require('../../../static/images/gameNewPic/9bac.jpg'),
                        listImg: [
                            {
                                idx: 9,
                                url: picUrl9,
                            }, 
                            {
                                idx: 10,
                                url: picUrl10,
                            }, 
                            {
                                idx: 0,
                                url: picUrl11,
                            }, 
                            {
                                idx: 1,
                                url: picUrl1,
                            }, 
                            {
                                idx: 2,
                                url: picUrl2,
                            }, 
                            
                        ]
                    },
                    {
                        title: 'Word Villas',
                        describe: '破解字谜，收集奖励，一起打造属于自己的温馨住宅。这里有跌宕起伏的剧情故事，母女的分歧，前男友的纠缠，闺蜜的纷争……主角的烦恼等着你来解决！这里有数百件漂亮家具，少女心，公主梦，温馨家具……等着你来解锁！',
                        imgSrc: require('../../../static/images/gameNewPic/10bac.jpg'),
                        listImg: [
                            {
                                idx: 10,
                                url: picUrl10,
                            }, 
                            {
                                idx: 0,
                                url: picUrl11,
                            }, 
                            {
                                idx: 1,
                                url: picUrl1,
                            }, 
                            {
                                idx: 2,
                                url: picUrl2,
                            }, 
                            {
                                idx: 3,
                                url: picUrl3,
                            }, 
                        ]
                    },
                   
            ]
        }
    },
    computed: {

    },
    methods: {
        changeCarousel(newP, oldP) {
            console.log(newP)
            if (newP < this.gameData.length - 2) {
                this.curPage = '0'+(newP+1);
            } else {
                this.curPage = ''+(newP+1);
            }
            this.curInx = newP;
        },
        toNext() {
            this.$refs.carousel.next()
        },
        setActiveItemCaro(i) {
            this.$refs.carousel.setActiveItem(i)
        }
    }
}
</script>
<style lang="less" scoped>
.medium-box{
    position: absolute;
    left: 0;
    top: 240px;
    >span{
        font-size: 16px;
    }
    img{
        width: 80px;
        margin-left: 15px;
        vertical-align: middle;
    }
}
#doubleCarousel{
    position:relative;
    height:100vh;
    overflow:hidden;
    min-width: 1380px;
    margin: 0 auto;
}

  .el-carousel__item h3 {
    color: #fff;
    font-size: 18px;
    opacity: 1;
    line-height: 300px;
    margin: 0;
  }
  .carOutBox{
      position:relative;
    //   height: 1080px;
      width:100%;
  }
  .carWords{
    //   position:absolute; 
    //   left: 60px;
    //   top: 379px;
    //   bottom: 138px;
      text-align: left;
      color: #FFFFFF;
      .tit{
        // font-family: 'Source Han Sans CN';
        height: 41px;
        font-size: 36px;
        font-weight: 400;
      }
      .carDivider{
        width: 57px;
        height: 3px;
        background: #FFFFFF; 
        margin: 43px 0 40px;
      }
      .carDescri{
        width: 468px;
        font-size: 14px;
        // font-family: 'Source Han Sans CN';
        font-weight: 400;
        color: #FFFFFF;
        opacity: 1;
        line-height:22px;
      }
      .carBtn{
          margin-top: 90px;
          img{
              margin-right: 30px;
          }
      }
  }
  .carCards{
      .cCard{
          width:168px;
          height:248px;
          float:left;
          margin-right:15px;
          border-radius: 14px;
      }

      .cCardNot{
          background:#000;
      }
  }
  .carouseBox{
      height: 292px;
      width:1000px;
      position: absolute;
      right: -144px;
    //   top:387px;
      bottom: 180px;
      animation: 1.35s;
      .cCPic{
            width:168px;
            height:248px;            
            position: relative;
            border-radius: 14px;
        }
      .cCPicOn {
          opacity: 1;
          top:-0px;
          left: -15px;
          transform: scale(1.17);  /*开始为原始大小*/
          box-shadow: 0px 0px 15px #fffa688a;
          z-index: 10000;
      } 
      .cCPicNot{
          opacity: 0.6;
      }

  }

  .carBac{
        position:absolute;
        background: url('../../../static/images/gameNewPic/1bac.jpg') no-repeat;
        background-size: cover;
        opacity: 0.4;
        height: 100vh;
        width:100vw;
        top: 0;
        bottom:0;   
        
        mask: linear-gradient(transparent , #fff 0);
        mask-size: 100% 100%;
        mask-position:50% 50%;
        mask-repeat: no-repeat;
    }
    .carContain{
        // position:relative;
        position: absolute;
        left: 60px;
        bottom: 138px;
        z-index: 200;
        
    }
  .caPage{
    position:absolute;
    // top: 742px;
    bottom: 100px;
    right:40px;
    height: 21px;
    font-size: 24px;
    // font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 0px;
    color: #FFFFFF;
    z-index: 2000;
}
      .animats{
            position:relative;
            // animation:mymove 1.35s infinite;
            animation:mymove 0.8s;
            -webkit-animation:mymove 0.8s; /*Safari and Chrome*/
            // animation-direction:alternate;/*轮流反向播放动画。*/
            animation-timing-function: linear; /*动画的速度曲线*/
            /* Safari 和 Chrome */
            -webkit-animation:mymove 0.8s;
            // -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
            -webkit-animation-timing-function: linear; /*动画的速度曲线*/
            // animation-delay: 0.4s;
            // -webkit-animation-delay: 0.4s;
            // animation-fill-mode : backwards;
            // -webkit-animation-fill-mode : backwards
        }

        @keyframes mymove
            {
                0%{
                    mask:
                    linear-gradient(transparent , #fff 0);
                    mask-size: 40% 40%;
                    mask-position:50% 50%;
                    mask-repeat: no-repeat;
                }
                100%{
                    mask:
                        linear-gradient(transparent , #fff 0);
                        mask-size: 100% 100%;
                        mask-position:50% 50%;
                        mask-repeat: no-repeat;
                }

            }
        .animatsWords{
            // position:relative;
            // animation:mymove 1.35s infinite;
            animation:wordmove 1s;
            animation-delay: 10s;
            -webkit-animation-delay: 10s;
            -webkit-animation:wordmove 1s; /*Safari and Chrome*/
            // animation-direction:alternate;/*轮流反向播放动画。*/
            animation-timing-function: linear; /*动画的速度曲线*/
            /* Safari 和 Chrome */
            -webkit-animation:wordmove 1s;
            // -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
            -webkit-animation-timing-function: linear; /*动画的速度曲线*/
        }

        @keyframes wordmove
            {
                0%{
                    transform: translate(0px, 250px);
                    opacity: 0;
                }
                50%{
                    transform: translate(0px, 250px);
                    opacity: 0;
                }
                75%{
                    transform: translate(0px, 90px);
                }
                100%{
                    opacity: 1;
                    transform: translate(0px, 0px)
                }

            }
        .bigLight{
            position:relative;
            // animation:mymove 1.35s infinite;
            animation:cardsmove 1.35s;
            -webkit-animation:cardsmove 1.35s; /*Safari and Chrome*/
            // animation-direction:alternate;/*轮流反向播放动画。*/
            animation-timing-function: linear; /*动画的速度曲线*/
            /* Safari 和 Chrome */
            -webkit-animation:cardsmove 1.35s;
            // -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
            -webkit-animation-timing-function: linear; /*动画的速度曲线*/
        }
        @keyframes cardsmove
            {
                0%{
                transform: scale(1.17);
                box-shadow: 0px 0px 15px #FFFA68;
                opacity: 0.3;
                }
                25%{
                    transform: scale(1); 
                }
                50%{
                    transform: scale(1.17);
                }
                100%{
                    transform: scale(1.17);
                    opacity: 1;
                    box-shadow: 0px 0px 15px #FFFA68;

                }

            }
</style>


// WEBPACK FOOTER //
// src/components/parts/doubleCarousel.vue